import { Module, Action } from "vuex-class-modules"
import { store } from "../store"
import { BaseModule } from "@/models/BaseModule"
import { Endpoint } from "@/services/endpoints"
import { Modules } from "../modules"
import { apiService } from "@/services/api.service"
import { AlertContentItem, AlertType } from "@/models"
import { AlertActions, alertModule } from "@/store/modules/alert.module"

export enum EmailVerificationActions {
  EMAIL_VERIFICATION_SEND = "EMAIL_VERIFICATION_SEND",
  EMAIL_VERIFICATION_RESEND = "EMAIL_VERIFICATION_RESEND",
}

@Module
class EmailVerificationModule extends BaseModule {
  @Action
  async [EmailVerificationActions.EMAIL_VERIFICATION_SEND]() {
    const data = await apiService.post<any>(Endpoint.EMAIL_VERIFICATION_SEND())
    return this.handleResponse<void>(data, ()=>{
      const alertContent: AlertContentItem[] = [
        {
          text: "Verification email",
          type: "bold",
        },
        {
          text: " has been sent.",
          type: "regular",
        },
      ]

      alertModule[AlertActions.SHOW_ALERT]({
        type: AlertType.SUCCESS,
        theme: "toast",
        content: alertContent,
      })
    })
  }

  @Action
  async [EmailVerificationActions.EMAIL_VERIFICATION_RESEND]() {
    const data = await apiService.post<any>(Endpoint.EMAIL_VERIFICATION_RESEND())
    return this.handleResponse<void>(data, ()=>{
      const alertContent: AlertContentItem[] = [
        {
          text: "Verification email",
          type: "bold",
        },
        {
          text: " has been resent.",
          type: "regular",
        },
      ]

      alertModule[AlertActions.SHOW_ALERT]({
        type: AlertType.SUCCESS,
        theme: "toast",
        content: alertContent,
      })
    })
  }
}

export const emailVerificationModule = new EmailVerificationModule({
  store,
  name: Modules.EMAIL_VERIFICATION,
})
